// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__q+Ptf"};